import { put, call, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    GET_KPI_DASHBOARDS_METADATA_REQUEST, getKpiDashboardsMetadataSuccess, getKpiDashboardsMetadataFail,
    GET_KPI_SOURCES_METADATA_REQUEST, getKpiSourcesMetadataSuccess, getKpiSourcesMetadataFail,
    GET_KPI_FIELDS_METADATA_REQUEST, getKpiFieldsMetadataSuccess, getKpiFieldsMetadataFail,
    GET_KPI_WIDGET_PREVIEW_REQUEST, getKpiWidgetPreviewSuccess, getKpiWidgetPreviewFail,
    GET_KPI_DASHBOARD_PREVIEW_REQUEST, getKpiDashboardPreviewSuccess, getKpiDashboardPreviewFail,
    CREATE_KPI_CONFIGURATION_REQUEST, createKpiConfigurationSuccess, createKpiConfigurationFail,
    UPDATE_KPI_CONFIGURATION_REQUEST, updateKpiConfigurationSuccess, updateKpiConfigurationFail,
    DELETE_KPI_CONFIGURATION_REQUEST, deleteKpiConfigurationSuccess, deleteKpiConfigurationFail,
    GET_ALL_KPI_CONFIGURATIONS_REQUEST, getAllKpiConfigurationsSuccess, getAllKpiConfigurationsFail,
    GET_KPI_DASHBOARD_DATA_REQUEST, getKpiDashboardDataSuccess, getKpiDashboardDataFail
} from '../actions/kpiActions';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest, extractErrorMessage } from '../../../api';

const safeArray = (value) => (Array.isArray(value) ? value : []);
const safeDashboardPayload = (payload) => ({
    widgets: safeArray(payload?.widgets)
});
const getToken = () => sessionStorage.getItem('token');

function* getKpiDashboardsMetadataSaga(action) {
    const { moduleKey, roleKey } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/metadata/dashboards?module=${moduleKey}&role=${roleKey}`;
    try {
        const resp = yield call(getRequest, { url, token: getToken() });
        yield put(getKpiDashboardsMetadataSuccess(safeArray(resp.data)));
    } catch (error) {
        yield put(getKpiDashboardsMetadataFail(extractErrorMessage(error, error.message)));
    }
}

function* getKpiSourcesMetadataSaga(action) {
    const { moduleKey } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/metadata/sources?module=${moduleKey}`;
    try {
        const resp = yield call(getRequest, { url, token: getToken() });
        yield put(getKpiSourcesMetadataSuccess(safeArray(resp.data)));
    } catch (error) {
        yield put(getKpiSourcesMetadataFail(extractErrorMessage(error, error.message)));
    }
}

function* getKpiFieldsMetadataSaga(action) {
    const { sourceKey } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/metadata/fields?source=${sourceKey}`;
    try {
        const resp = yield call(getRequest, { url, token: getToken() });
        yield put(getKpiFieldsMetadataSuccess(safeArray(resp.data)));
    } catch (error) {
        yield put(getKpiFieldsMetadataFail(extractErrorMessage(error, error.message)));
    }
}

function* getKpiWidgetPreviewSaga(action) {
    const url = `${API_BASE_URL}/api/kpi/preview/widget`;
    try {
        const resp = yield call(postRequest, { url, data: action.payload, token: getToken() });
        yield put(getKpiWidgetPreviewSuccess(resp.data ? { ...resp.data, isSimulated: true } : null));
    } catch (error) {
        yield put(getKpiWidgetPreviewFail(extractErrorMessage(error, error.message)));
    }
}

function* getKpiDashboardPreviewSaga(action) {
    const { dashboardKey, config } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/preview/dashboard/${dashboardKey}`;
    try {
        const resp = yield call(postRequest, { url, data: config, token: getToken() });
        yield put(getKpiDashboardPreviewSuccess(safeDashboardPayload(resp.data)));
    } catch (error) {
        yield put(getKpiDashboardPreviewFail(extractErrorMessage(error, error.message)));
    }
}

function* createKpiConfigurationSaga(action) {
    const url = `${API_BASE_URL}/api/kpi/configurations`;
    try {
        const resp = yield call(postRequest, { url, data: action.payload, token: getToken() });
        yield put(createKpiConfigurationSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: 'success', title: 'Succes', text: 'KPI enregistre avec succes', timer: 2000, showConfirmButton: false });
    } catch (error) {
        const message = extractErrorMessage(error, error.message);
        yield put(createKpiConfigurationFail(message));
        yield call([Swal, Swal.fire], { icon: 'error', title: 'Erreur', text: message });
    }
}

function* updateKpiConfigurationSaga(action) {
    const { id, data } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/configurations/${id}`;
    try {
        const resp = yield call(putRequest, { url, data, token: getToken() });
        yield put(updateKpiConfigurationSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: 'success', title: 'Succes', text: 'KPI mis a jour avec succes', timer: 2000, showConfirmButton: false });
    } catch (error) {
        yield put(updateKpiConfigurationFail(extractErrorMessage(error, error.message)));
    }
}

function* deleteKpiConfigurationSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/configurations/${id}`;
    try {
        yield call(deleteRequest, { url, token: getToken() });
        yield put(deleteKpiConfigurationSuccess(id));
        yield call([Swal, Swal.fire], { icon: 'success', title: 'Supprime', text: 'KPI supprime', timer: 2000, showConfirmButton: false });
    } catch (error) {
        yield put(deleteKpiConfigurationFail(extractErrorMessage(error, error.message)));
    }
}

function* getAllKpiConfigurationsSaga() {
    const url = `${API_BASE_URL}/api/kpi/configurations`;
    try {
        const resp = yield call(getRequest, { url, token: getToken() });
        yield put(getAllKpiConfigurationsSuccess(safeArray(resp.data)));
    } catch (error) {
        yield put(getAllKpiConfigurationsFail(extractErrorMessage(error, error.message)));
    }
}

function* getKpiDashboardDataSaga(action) {
    const { dashboardKey, runtimeFilters } = action.payload;
    const url = `${API_BASE_URL}/api/kpi/data/dashboard/${dashboardKey}`;
    try {
        const resp = yield call(postRequest, { url, data: runtimeFilters || {}, token: getToken() });
        yield put(getKpiDashboardDataSuccess(safeDashboardPayload(resp.data)));
    } catch (error) {
        yield put(getKpiDashboardDataFail(extractErrorMessage(error, error.message)));
    }
}

export default function* kpiSagas() {
    yield all([
        takeLatest(GET_KPI_DASHBOARDS_METADATA_REQUEST, getKpiDashboardsMetadataSaga),
        takeLatest(GET_KPI_SOURCES_METADATA_REQUEST, getKpiSourcesMetadataSaga),
        takeLatest(GET_KPI_FIELDS_METADATA_REQUEST, getKpiFieldsMetadataSaga),
        takeLatest(GET_KPI_WIDGET_PREVIEW_REQUEST, getKpiWidgetPreviewSaga),
        takeLatest(GET_KPI_DASHBOARD_PREVIEW_REQUEST, getKpiDashboardPreviewSaga),
        takeLatest(CREATE_KPI_CONFIGURATION_REQUEST, createKpiConfigurationSaga),
        takeLatest(UPDATE_KPI_CONFIGURATION_REQUEST, updateKpiConfigurationSaga),
        takeLatest(DELETE_KPI_CONFIGURATION_REQUEST, deleteKpiConfigurationSaga),
        takeLatest(GET_ALL_KPI_CONFIGURATIONS_REQUEST, getAllKpiConfigurationsSaga),
        takeLatest(GET_KPI_DASHBOARD_DATA_REQUEST, getKpiDashboardDataSaga)
    ]);
}
